import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-declaracion-accesibilidad',
  templateUrl: './declaracion-accesibilidad.component.html',
  styleUrls: ['./declaracion-accesibilidad.component.css']
})
export class DeclaracionAccesibilidadComponent implements AfterViewInit{
  basePath = environment.baseUrl; // O cualquier variable que tengas en environment.ts
  version: string = "";
  dateYear: number = 0;

  constructor(private elementRef: ElementRef, private router: Router) {
    this.version = localStorage.getItem('version') || '';
    this.getDateYear();
  }


  /**
* Get Year For All Rights Reserved
*/
  getDateYear() {
    const currenDate = new Date();
    this.dateYear = currenDate.getFullYear();
  }
  ngAfterViewInit(): void {

    const contenidoPrincipal = this.elementRef.nativeElement.querySelector('#contenido-principal');

    if (contenidoPrincipal) {
      contenidoPrincipal.scrollIntoView({ block: 'start' });
    }
  }

  goToHomepage() {
    this.router.navigate(['/inicio']);
  }

}
